export default "__VITE_ASSET__CMeyt6Tc__"